// Public marketing site data layer — Phase 3 Module 10.
//
// Fetches via anon Supabase RPC (no auth required). The submit flow
// goes through the FastAPI backend so it can also fan out admin
// notifications and hit the audit log — keeping the anon DB surface
// tiny while still producing proper notifications_log rows.

import axios from "axios";
import { supabase, isSupabaseConfigured } from "./supabase";

const API = process.env.REACT_APP_BACKEND_URL;

/**
 * Load the public site bundle for an organization slug.
 * Returns `{ org, pages, announcements }` or null if the org is unknown.
 */
export async function getPublicSite(orgSlug) {
  if (!isSupabaseConfigured) return null;
  const { data, error } = await supabase.rpc("rpc_get_public_site", {
    p_org_slug: orgSlug,
  });
  if (error) throw error;
  return data || null;
}

/**
 * Submit an enrollment inquiry. Returns `{status, inquiry_id, admins_notified}`.
 * Throws with a user-facing message on business-rule rejections
 * ("closed", "throttled", invalid fields).
 */
export async function submitEnrollmentInquiry(payload) {
  const res = await axios.post(
    `${API}/api/notifications/send/enrollment-inquiry`,
    payload,
    { validateStatus: () => true },
  );
  if (res.status >= 400) {
    const detail = res.data?.detail || res.data?.message || "Could not submit inquiry";
    // Postgres P0001 messages are wrapped by PostgREST as JSON {code,message,...}.
    // Surface the most helpful string we can find.
    if (typeof detail === "object") {
      throw new Error(detail.message || detail.hint || JSON.stringify(detail));
    }
    throw new Error(String(detail).slice(0, 300));
  }
  return res.data;
}
